import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import UserInfo from '@ifeng-fe/ui_pc_userInfo';

class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { url, logo },
        } = this.props;

        return (
            <div className={styles.header_box}>
                <div className={styles.header}>
                    <div className={styles.channel}>
                        <a href={url} target="_blank">
                            <img src={logo} height="24" />
                        </a>
                    </div>
                    <table className={styles.user}>
                        <tbody>
                            <tr>
                                <th>
                                    <a className={styles.link} href="//www.ifeng.com" target="_blank">
                                        凤凰网首页
                                    </a>
                                </th>
                                <th className={styles.devide}>|</th>
                                <th>
                                    <NoSSR>
                                        <UserInfo />
                                    </NoSSR>
                                </th>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Header);
